import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Grid } from '@iho-design-system/Loader';
import HistoryComponent from '../components/request/History';
import ListComponent from '../components/request/List';
import ToolbarComponent from '../components/request/Toolbar';
import getAPI from '../api/get';

const Request = () => {
  const navigate = useNavigate();
  const urlParameters = useParams();

  const [requestData, setRequestData] = useState({ userTickets: '' });
  const [selectedRequest, setSelectedRequest] = useState([]);
  const [toggleHistory, setToggleHistory] = useState(false);
  const [advancedSearchParameters, setAdvancedSearchParameters] = useState({
    RequestKey: -1,
    TicketStatus: -1,
    AddDate: ''
  });
  const [reloadRequest, setReloadRequest] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      const parameters = {
        ctrl: 'UserProfile',
        method: 'GetUserTickets',
        query: '?PageIndex=1&PageSize=10'
      };
      setRequestData({ userTickets: await getAPI(parameters) });
    };
    fetchData();
  }, [toggleHistory, reloadRequest]);

  const reloadRequestProps = (value) => {
    setRequestData({ userTickets: '' });
    setAdvancedSearchParameters('');
    setReloadRequest(value);
  };

  const requestIdSearchProps = async (requestId) => {
    const parameters = {
      ctrl: 'UserProfile',
      method: 'GetUserTickets',
      query: `?PageIndex=1&PageSize=10&Code=${requestId}`
    };
    setRequestData({ ...requestData, userTickets: await getAPI(parameters) });
  };

  const advancedSearchProps = async (params) => {
    const query = `?PageIndex=1&PageSize=10&AddDate=${params.AddDate}&TicketStatus=${+params.TicketStatus === -1 ? '' : params.TicketStatus}&RequestKey=${+params.RequestKey === -1 ? '' : params.RequestKey}`;
    setAdvancedSearchParameters(params);
    setRequestData({ ...requestData, userTickets: await getAPI({ ctrl: 'UserProfile', method: 'GetUserTickets', query }) });
  };

  const selectedRequestProps = (request) => {
    setSelectedRequest(request);
    navigate('/request/history');
    setToggleHistory(true);
  };

  const toggleHistoryProps = () => {
    navigate('/request');
    setToggleHistory(false);
  };

  useEffect(() => {
    setToggleHistory(urlParameters?.history === 'history');
  }, [urlParameters]);

  const paginationProps = async (pageChange) => {
    if (!requestData.userTickets?.data) return;

    const { PageIndex, PageSize, TotalItems } = requestData.userTickets.data;
    const newIndex = PageIndex + pageChange;

    if (newIndex < 1 || newIndex > Math.ceil(TotalItems / PageSize)) return;

    const query = `?PageIndex=${newIndex}&PageSize=10&AddDate=${advancedSearchParameters.AddDate}&TicketStatus=${advancedSearchParameters.TicketStatus === -1 ? '' : advancedSearchParameters.TicketStatus}&RequestKey=${advancedSearchParameters.RequestKey === -1 ? '' : advancedSearchParameters.RequestKey}`;
    setRequestData({ ...requestData, userTickets: await getAPI({ ctrl: 'UserProfile', method: 'GetUserTickets', query }) });
  };

  const listData = { userTickets: requestData.userTickets };
  const historyData = { selectedRequest };

  return (
    <Container size="lg">
      <Grid>
        <Grid.Wrapper>
          {!toggleHistory && (
            <Grid.Item className="pr-0 pl-0" size="col-12">
              <ToolbarComponent
                requestIdSearchProps={requestIdSearchProps}
                advancedSearchProps={advancedSearchProps}
                reloadRequestProps={reloadRequestProps}
              />
            </Grid.Item>
          )}
          {!toggleHistory && (
            <Grid.Item className="pr-0 pl-0" size="col-12">
              <ListComponent
                props={listData}
                selectedRequestProps={selectedRequestProps}
                paginationProps={paginationProps}
              />
            </Grid.Item>
          )}
          {toggleHistory && (
            <Grid.Item size="col-12">
              <HistoryComponent props={historyData} toggleHistoryProps={toggleHistoryProps} />
            </Grid.Item>
          )}
        </Grid.Wrapper>
      </Grid>
    </Container>
  );
};

export default Request;
